import { render, staticRenderFns } from "./CustomerCreditDetail.vue?vue&type=template&id=7cf0dcf0"
import script from "./CustomerCreditDetail.vue?vue&type=script&lang=js"
export * from "./CustomerCreditDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports